import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { TextComponent } from "../../components";
import Customers from "./Customers";
import Dealership from "./Dealership";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import AntdTab from "../../components/AntdTab/AntdTab";
import ResetPassword from "../Auth/ResetPasswrd";

export const CompanyPortal = () => {
  const permissionarr = useSelector(
    (state) => state.AuthReducer.user?.permissions,
  );

  // const isReset = useSelector((state) => state.AuthReducer.isReset);

  const hasManageCustomers =
    Number(
      permissionarr?.find((p) => p.name === "manage_customers")?.is_access,
    ) === 1;

  const hasManageDealerships =
    Number(
      permissionarr?.find((p) => p.name === "manage_dealerships")?.is_access,
    ) === 1;

  // const [items, setItems] = useState([]);
  const [ActiveTab, setActiveTab] = useState("1");

  const items = [
    {
      key: "1",
      label: "Customers",
      children: <Customers />,
      permission: "manage_customers",
    },
    {
      key: "2",
      label: "Dealerships",
      children: <Dealership />,
      permission: "manage_dealerships",
    },
  ];

  const filteredItems = items.filter((item) => {
    if (item.permission === "manage_customers") {
      return hasManageCustomers;
    }
    if (item.permission === "manage_dealerships") {
      return hasManageDealerships;
    }
    return false;
  });

  useEffect(() => {
    if (
      filteredItems.length &&
      !filteredItems.find((t) => t.key === ActiveTab)
    ) {
      setActiveTab(filteredItems[0].key);
    }
  }, [filteredItems]);

  return (
    <div>
      <div className={styles.mainCont}>
        {/* <Tabs
          defaultActiveKey="1"
          activeKey={ActiveTab}
          setActiveTab={setActiveTab}
          items={items}
          animated
          renderTabBar={(props) => {
            return (
              <>
                <div className={`${styles.tabsMainCont}`}>
                  <div className={`${styles.tabsCont}`}>
                    {props.panes.map((tab) => (
                      <div
                        key={tab.props.tabKey}
                        className={`${styles.tabCol} ${
                          props.activeKey == tab.props.tabKey &&
                          styles.activeTab
                        }`}
                        onClick={() => {
                          setActiveTab(tab.props.tabKey);
                        }}
                      >
                        <TextComponent
                          text={tab.props.tab}
                          className={`${styles.tabText}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </>
            );
          }}
        /> */}
        <AntdTab
          ActiveTab={ActiveTab}
          setActiveTab={setActiveTab}
          items={filteredItems}
          tabsClass={styles.tabsCont}
          tabsColclass={styles.tabCol}
        />
      </div>
      {/* <ResetPassword
        open={isReset}
      /> */}
    </div>
  );
};
